import React from 'react';
import { REGION_GROUPS, displayBundesland } from '@radevents/shared';

/**
 * Country-grouped <option> list for a Bundesland/Kanton <select>.
 * Rendert die Regionen von DE/AT/CH als <optgroup>s und darunter die weiteren Länder
 * (Italien, Belgien, …) in einer Sammelgruppe — dort ist der Landesname selbst der Regionswert.
 * Place directly inside a <select>; provide your own placeholder <option> before it if needed.
 */
export default function BundeslandOptions() {
  return (
    <>
      {REGION_GROUPS.map(group => (
        <optgroup key={group.label} label={group.label}>
          {group.regions.map(bl => (
            <option key={bl} value={bl}>{displayBundesland(bl)}</option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
